"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AfbeeldingenController = void 0;
const _ = require("lodash");
class AfbeeldingenController {
    constructor($scope, $q, imageService, $location, userService) {
        this.$scope = $scope;
        this.$q = $q;
        this.imageService = imageService;
        this.$location = $location;
        this.userService = userService;
        var isSearching = false, isUploading = false;
        $scope.isSearching = () => isSearching;
        $scope.isUploading = () => isUploading;
        $scope.search = () => {
            isSearching = true;
            imageService.getImage($scope.imageId)
                .then((image) => { $scope.image = image; })
                .finally(() => { isSearching = false; });
        };
        $scope.$watch("image.id", (newValue, oldValue) => {
            // Clear selected files for upload
            $scope.files = null;
        });
        $scope.onFileSelect = ($files) => {
            $scope.files = $files;
        };
        $scope.hasAssetFormats = () => {
            return $scope.image.assetFormats && $scope.image.assetFormats.length > 0;
        };
        $scope.filesAreUploaded = function () {
            if (!$scope.files) {
                return true;
            }
            return _.every($scope.files, function (file) {
                return file.percentageComplete === 100;
            });
        };
        $scope.submit = () => {
            if ($scope.hasAssetFormats() && !confirm('U gaat de afbeelding overschrijven weet u dit zeker?')) {
                $scope.files = null;
                return;
            }
            var promises = [];
            isUploading = true;
            _.each($scope.files, function (file) {
                promises.push(imageService.upload($scope.image.id, file));
            });
            $q.all(promises).finally(() => {
                isUploading = false;
                $scope.search();
            });
        };
    }
}
exports.AfbeeldingenController = AfbeeldingenController;
AfbeeldingenController.$inject = [
    '$scope',
    '$q',
    'imageService',
    '$location',
    'userService'
];
